import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $q, ModalService, ServiceRequestService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        const serviceRequest = $state.$current.data.serviceRequest;
        $state.$current.data.serviceRequest = null;
        $scope.actionView = null;

        $scope.today = new Date();
        $scope.today.setHours(0, 0, 0, 0);

        if ($state.$current.data.action === 'specialistacceptedwork') {
            $scope.actionView = ViewModelService.create({
                serviceRequestNumber: serviceRequest.serviceRequestNumber,
                completionDate: new Date()
            }, 'cc', 'edge.capabilities.servicerequest.dto.ServiceRequestAcceptWorkDTO');
        } else if ($state.$current.data.action === 'vendordelayed') {
            $scope.actionView = ViewModelService.create({
                serviceRequestNumber: serviceRequest.serviceRequestNumber,
                newCompletionDate: new Date()
            }, 'cc', 'edge.capabilities.servicerequest.dto.ServiceRequestReportDelayDTO');
        } else {
            $scope.expectedCompletionDate = serviceRequest.expectedQuoteCompletionDate || new Date();
            $scope.reasonForDeclining = '';

            if (!$scope.actionView) {
                $scope.actionView = ViewModelService.create({
                    serviceRequestNumber: serviceRequest.serviceRequestNumber
                }, 'cc', 'edge.capabilities.servicerequest.dto.ServiceRequestActionDTO');
            }
        }
    };

    ctrl.acceptWork = (acceptWorkForm) => {
        acceptWorkForm.submitted = true;
        if ($scope.actionView.aspects.subtreeValid) {
            $scope.acceptWorkPromise = ServiceRequestService.acceptWork($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Accepting work failed',
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                    );
                }
            );
        }
    };

    ctrl.declineWork = (declineWorkForm) => {
        declineWorkForm.submitted = true;
        if ($scope.actionView.aspects.subtreeValid) {
            $scope.declineWorkPromise = ServiceRequestService.declineWork($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Declining work failed',
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                    );
                }
            );
        }
    };

    ctrl.cancelServiceRequest = (cancelServiceRequestForm) => {
        cancelServiceRequestForm.submitted = true;
        if ($scope.actionView.aspects.subtreeValid) {
            $scope.cancelServiceRequestPromise = ServiceRequestService.cancelServiceRequest($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Cancelling service request failed',
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                    );
                }
            );
        }
    };

    ctrl.reportBlocked = (reportBlockedForm) => {
        reportBlockedForm.submitted = true;
        if ($scope.actionView.aspects.subtreeValid) {
            $scope.reportBlockedPromise = ServiceRequestService.reportBlocked($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Reporting blockage failed',
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                    );
                }
            );
        }
    };

    ctrl.reportDelay = (reportDelayForm) => {
        reportDelayForm.submitted = true;
        if ($scope.actionView.aspects.subtreeValid) {
            $scope.reportDelayPromise = ServiceRequestService.reportDelay($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                () => {
                    ModalService.showError(
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Reporting delay failed',
                        'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                    );
                }
            );
        }
    };

    ctrl.completeWork = () => {
        $scope.completeWorkPromise = ServiceRequestService.completeWork($scope.actionView.serviceRequestNumber.value).then(
            () => {
                $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
            },
            () => {
                ModalService.showError(
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Completing work failed',
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                );
            }
        );
    };

    ctrl.resumeWork = () => {
        $scope.resumeWorkPromise = ServiceRequestService.resumeWork($scope.actionView.serviceRequestNumber.value).then(
            () => {
                $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
            },
            () => {
                ModalService.showError(
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Resuming work failed',
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                );
            }
        );
    };

    ctrl.closeService = () => {
        $scope.closeServicePromise = ServiceRequestService.closeServiceRequest_EY($scope.actionView.serviceRequestNumber.value).then(
            () => {
                $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
             },
            () => {
                ModalService.showError(
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Close Service failed',
                    'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
                );
            }
        );
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$q', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService'];
export default fn;
